export default Object.freeze({
    SeleccionSimple: 1,
    SeleccionMultiple: 2,
    SeleccionSimpleInformaciónEvidencia: 3,
    SeleccionSingularVertical: 4,
    SeleccionSingularHorizontal: 5,
    TextoAbierto: 6,
    TextoNumerico: 7,
    SinTexto: 8,
    SeleccionMultipleHijos: 9,
    Documento: 10,
    Estado: 11,
    Municipio: 12,
});